/**
 * This file was automatically generated and should not be edited.
 * Source: tokens.json from Figma variables (/sync-design-tokens) via scripts/generateTokensFromFigma.mjs
 */
export const NEUTRAL_0 = 'var(--neutral-0)';
export const NEUTRAL_050 = 'var(--neutral-050)';
export const NEUTRAL_075 = 'var(--neutral-075)';
export const NEUTRAL_100 = 'var(--neutral-100)';
export const NEUTRAL_200 = 'var(--neutral-200)';
export const NEUTRAL_300 = 'var(--neutral-300)';
export const NEUTRAL_400 = 'var(--neutral-400)';
export const NEUTRAL_500 = 'var(--neutral-500)';
export const NEUTRAL_600 = 'var(--neutral-600)';
export const NEUTRAL_700 = 'var(--neutral-700)';
export const NEUTRAL_800 = 'var(--neutral-800)';
export const NEUTRAL_900 = 'var(--neutral-900)';
export const BLUE_050 = 'var(--blue-050)';
export const BLUE_100 = 'var(--blue-100)';
export const BLUE_200 = 'var(--blue-200)';
export const BLUE_300 = 'var(--blue-300)';
export const BLUE_400 = 'var(--blue-400)';
export const BLUE_500 = 'var(--blue-500)';
export const BLUE_600 = 'var(--blue-600)';
export const BLUE_700 = 'var(--blue-700)';
export const BLUE_800 = 'var(--blue-800)';
export const BLUE_900 = 'var(--blue-900)';
export const YELLOW_050 = 'var(--yellow-050)';
export const YELLOW_100 = 'var(--yellow-100)';
export const YELLOW_200 = 'var(--yellow-200)';
export const YELLOW_300 = 'var(--yellow-300)';
export const YELLOW_400 = 'var(--yellow-400)';
export const YELLOW_500 = 'var(--yellow-500)';
export const YELLOW_600 = 'var(--yellow-600)';
export const YELLOW_700 = 'var(--yellow-700)';
export const YELLOW_800 = 'var(--yellow-800)';
export const YELLOW_900 = 'var(--yellow-900)';
export const GREEN_050 = 'var(--green-050)';
export const GREEN_100 = 'var(--green-100)';
export const GREEN_200 = 'var(--green-200)';
export const GREEN_300 = 'var(--green-300)';
export const GREEN_400 = 'var(--green-400)';
export const GREEN_500 = 'var(--green-500)';
export const GREEN_600 = 'var(--green-600)';
export const GREEN_700 = 'var(--green-700)';
export const GREEN_800 = 'var(--green-800)';
export const GREEN_900 = 'var(--green-900)';
export const RED_050 = 'var(--red-050)';
export const RED_100 = 'var(--red-100)';
export const RED_200 = 'var(--red-200)';
export const RED_300 = 'var(--red-300)';
export const RED_400 = 'var(--red-400)';
export const RED_500 = 'var(--red-500)';
export const RED_600 = 'var(--red-600)';
export const RED_700 = 'var(--red-700)';
export const RED_800 = 'var(--red-800)';
export const RED_900 = 'var(--red-900)';
export const BLACK_ALPHA_0 = 'var(--black-alpha-0)';
export const BLACK_ALPHA_001 = 'var(--black-alpha-001)';
export const BLACK_ALPHA_002 = 'var(--black-alpha-002)';
export const BLACK_ALPHA_003 = 'var(--black-alpha-003)';
export const BLACK_ALPHA_004 = 'var(--black-alpha-004)';
export const BLACK_ALPHA_005 = 'var(--black-alpha-005)';
export const BLACK_ALPHA_006 = 'var(--black-alpha-006)';
export const BLACK_ALPHA_007 = 'var(--black-alpha-007)';
export const BLACK_ALPHA_008 = 'var(--black-alpha-008)';
export const WHITE_ALPHA_0 = 'var(--white-alpha-0)';
export const WHITE_ALPHA_001 = 'var(--white-alpha-001)';
export const WHITE_ALPHA_002 = 'var(--white-alpha-002)';
export const WHITE_ALPHA_003 = 'var(--white-alpha-003)';
export const WHITE_ALPHA_004 = 'var(--white-alpha-004)';
export const WHITE_ALPHA_005 = 'var(--white-alpha-005)';
export const WHITE_ALPHA_006 = 'var(--white-alpha-006)';
export const WHITE_ALPHA_007 = 'var(--white-alpha-007)';
export const WHITE_ALPHA_008 = 'var(--white-alpha-008)';
export const PURPLE_050 = 'var(--purple-050)';
export const PURPLE_100 = 'var(--purple-100)';
export const PURPLE_200 = 'var(--purple-200)';
export const PURPLE_300 = 'var(--purple-300)';
export const PURPLE_400 = 'var(--purple-400)';
export const PURPLE_500 = 'var(--purple-500)';
export const PURPLE_600 = 'var(--purple-600)';
export const PURPLE_700 = 'var(--purple-700)';
export const PURPLE_800 = 'var(--purple-800)';
export const PURPLE_900 = 'var(--purple-900)';
